import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import NaibLogo from '../components/NaibLogo';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

function VerifyEmailSent() {
  const location = useLocation();
  const emailSent = location.state?.emailSent !== false;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-6">
        <div className="flex flex-col items-center">
          <NaibLogo logoClassName="h-9 w-9" nameClassName="h-7 w-auto max-w-[180px]" alt="Onahiri" />
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
            Check Your Email
          </h2>
          <div className="mt-2 text-center text-sm text-gray-600">
            {emailSent ? (
              <>
                <p>We've sent you a verification email.</p>
                <p className="mt-2">Please check your inbox and click the verification link to complete your registration.</p>
              </>
            ) : (
              <>
                <p>Your account is ready.</p>
                <p className="mt-2">Use the option below if you need another verification email.</p>
              </>
            )}
          </div>
        </div>

        <div className="rounded-md bg-blue-50 p-4">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <EnvelopeIcon className="h-5 w-5 text-blue-400" />
            </div>
            <div className="ml-3">
              <p className="text-sm text-blue-700">
                Didn't receive the email? Check your spam folder or{' '}
                <Link
                  to="/resend-verification"
                  className="font-medium text-blue-700 hover:text-blue-600"
                >
                  click here to resend
                </Link>
              </p>
            </div>
          </div>
        </div>

        <div className="text-center">
          <Link
            to="/login"
            className="font-medium text-indigo-600 hover:text-indigo-500"
          >
            Return to login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default VerifyEmailSent; 